<template>
  <div>
    <a-row justify="center" type="flex">
      <a-col :lg="12" :md="24" :sm="24" :xl="8" :xs="24" :xxl="8">
        <a-timeline :pending="
  isVerificationCompleted
    ? false
    : 'Proszę czekać! Trwa weryfikacja...'
" :style="{
        marginTop: '52px',
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '400px',
      }">
          <a-timeline-item :color="states[details.status].color">
            <a-icon slot="dot" :type="states[details.status].icon" style="font-size: 16px"/>
            <p class="timeline-item">Pobieranie szczegółów połączenia</p>
            <a-alert v-if="details.message" :message="details.message" type="error" show-icon />
          </a-timeline-item>
          <a-timeline-item :color="states[connection.status].color">
            <a-icon slot="dot" :type="states[connection.status].icon" style="font-size: 16px"/>
            <p class="timeline-item">Weryfikacja połączenia z siecią</p>
            <a-alert v-if="connection.message" :message="connection.message" type="error" show-icon />
          </a-timeline-item>
          <a-timeline-item :color="states[verification.status].color">
            <a-icon slot="dot" :type="states[verification.status].icon" style="font-size: 16px"/>
            <p class="timeline-item">Weryfikacja urządzenia</p>
            <a-alert v-if="verification.message" :message="verification.message" type="error" show-icon />
          </a-timeline-item>
        </a-timeline>
      </a-col>
      <a-col :lg="10" :md="0" :sm="0" :xl="8" :xs="0" :xxl="8">
        <VueLottiePlayer :animationData="require('@/assets/cloud-server.json')" :width="'auto'" loop
                         name="Server Animation" style="max-height: 400px; margin-top: 24px"/>
      </a-col>
    </a-row>

    <a-row style="text-align: center">
      <a-button :disabled="!isVerificationSuccess" type="primary" @click="submit">
        Dalej
        <a-icon type="right"/>
      </a-button>
    </a-row>
  </div>
</template>

<script>
import VueLottiePlayer from "vue-lottie-player";

export default {
  components: {
    VueLottiePlayer,
  },
  data() {
    return {
      states: {
        loading: {
          icon: "loading",
          color: "blue",
        },
        ok: {
          icon: "check",
          color: "green",
        },
        failed: {
          icon: "warning",
          color: "red",
        },
      },
      connection: {
        status: "loading",
        message: null
      },
      details: {
        status: "loading",
        message: null
      },
      verification: {
        status: "loading",
        message: null
      },
    };
  },
  mounted() {
    let verification = setInterval(() => {
      this.verify()
      if (this.isVerificationCompleted) {
        clearInterval(verification)
      }
    }, 1000)
  },
  methods: {
    submit: function () {
      this.$emit("nextStep");
    },
    verify: function () {
      console.log("Session: ", this.computedSession)
      if (this.computedSession.hasAccount) {
        this.verification.status = "failed"
        this.verification.message = "Urządzenie jest już zarejestrowane w systemie."
      } else {
        this.verification.status = "ok"
        this.verification.message = null
      }

      if (!this.computedSession.isLocalConnection) {
        this.connection.status = "failed"
        this.connection.message = "Urządzenie nie jest podłaczone do sieci kablem. Sprawdź połączenie i spróbuj ponownie."
      } else {
        this.connection.status = "ok"
        this.connection.message = null
      }

      if (this.computedSession.isLoggedIn) {
        this.details.status = "failed"
        this.details.message = "Jesteś zalogowany(na). Przejdź do konta i dodaj urządzenie z poziomu panelu użytkownika."
      } else {
        this.details.status = "ok"
        this.details.message = null
      }
    }
  },
  computed: {
    isVerificationSuccess: function () {
      return (
          this.connection.status === "ok" &&
          this.details.status === "ok" &&
          this.verification.status === "ok"
      );
    },
    isVerificationCompleted: function () {
      return (
          this.connection.status !== "loading" &&
          this.details.status !== "loading" &&
          this.verification.status !== "loading"
      );
    },
    computedSession: function () {
      return this.$store.getters.getUserConnectionDetails;
    },
  },
};
</script>

<style scoped>
.timeline-item {
  margin-bottom: 4px;
  font-weight: 500;
}
</style>